(function () {
    'use strict';


    // Fetch the configuration data & bootstrap the application manually
    fetchData().then(bootstrapApplication);
    
    // declare angular main app module 
    var module = angular.module('uwAgenda', [
        'ngRoute',
        'ngTouch',
        'ngLocale',
        'ngResource',
        'ui.router',
        'ui.bootstrap',
        'ui.select',
        'pascalprecht.translate',
        'ngSanitize',
        'ngStorage',
        'ncy-angular-breadcrumb',
        'oc.lazyLoad',
        'ngImgCrop',
        'angular.filter',
        'angular-cache',
        'nvd3',
        'ngPrint',
        'angularFileUpload',
        'ae-datetimepicker',
        'tmh.dynamicLocale',
        // uwAgenda Modules
        'uwAgenda.templates', // in development empty -> in production set by gulp
        'uwAgenda.global',
        'uwAgenda.login',
        'uwAgenda.users',
        'uwAgenda.tasks',
        'uwAgenda.ringfoon',
        'uwAgenda.settings.agendasettings',
        'uwAgenda.settings.messages',
        'uwAgenda.settings.aiagent',
        'uwAgenda.settings.administration',
        'uwAgenda.settings.grouppractice',
        'uwAgenda.agenda',
        'uwAgenda.email',
        'uwAgenda.charts',
        'uwAgenda.downloads',
        'uwAgenda.help',
        'uwAgenda.programinfo',
        'uwAgenda.version',
        'uwAgenda.search',
        'uwAgenda.views'/* Weergaven */,
        'uwAgenda.website',
        'uwAgenda.website.privacypolicy'
    ]);

    module.constant('Language', {
        "PreferredLanguage": "nl_BE",
        "SupportedLanguages": [
            {
                
            }
        ]
    });
    
    module.constant('PatientConstant', {
        "New" : "New",
        "Update" : "Update"
    });

    module.constant('Languages', {
        "Unknown" : { id: 0, iso: "?" },
        "English" : { id: 1, iso: "EN" },
        "German" : { id: 2, iso: "DE" },
        "Dutch" : { id: 3, iso: "NL" },
        "French" : { id: 4, iso: "FR" },
    });
    
    module.constant('OnlineBookingRoles', [
            { name: "Patient", value: 8 },
            { name: "Representative", value: 9 },
            { name: "Colleague", value: 11 }
    ])
    
    module.constant('UniqueIds', {
        "RingphoneHq": { value: '9A15B0BB-85B9-4F81-95FD-A6E071EBEA91' }
    });
    
    module.constant('RoleType', {
        "MainUser": { name: "MainUser", value: 1 },
        "SubuserAdmin": { name: "SubuserAdmin", value: 2 },
        "SubuserRestricted": { name: "SubuserRestricted", value: 3 },
        "RingfoonOperatorAdmin": { name: "RingfoonOperatorAdmin", value: 6 },
        "RingfoonOperatorRestricted": { name: "RingfoonOperatorRestricted", value: 7 },
        "Patient": { name: "Patient", value: 8 },
        "Representative": { name: "Representative", value: 9 },
        "RingfoonAdmin": { name: "RingfoonAdmin", value: 10 },
        "Colleague": { name: "Colleague", value: 11 }
    });
    module.constant('StartPageEnum', {
        "UrgentTodo": { name: "UrgentTodo", value: 1 },        
        "User": { name: "User", value: 3 },
        "AgendaDay": { name: "AgendaDay", value: 4 },
        "AgendaWeek": { name: "AgendaWeek", value: 5 },
        "AgendaSettings": { name: "AgendaSettings", value: 6 }
    });
    
    module.constant('ConfirmationMessageType', {
        "Email": { name: "Email", value: 1 },
        "Sms": { name: "Sms", value: 2 }
    });

    module.constant('WebsocketRegisterType', {
        "Notification": 1,
        "Badges": 2,
        "Agenda": 3,
        "AgendaSettings": 4,
        "ProgramInfoSave": 5,
        "ProgramInfoDelete": 6,
        "RingfoonDaytaskUpdate": 8,
        "RingfoonDaytaskAdd": 9,
        "RingfoonDaytaskDelete": 10,
        "TaskUpdate": 81,
        "TaskAdd": 91,
        "TaskDelete": 101,
        "TaskInform": 102,
        "NewCall": 11,
        "AnswerCall": 12,
        "DeclineCall": 13,
        "PhoneStatus": 14,
        "Dial": 15,
        "PauseWrapUp": 16,
        "StopWrapUp": 17,
        "OnWrapUpStart": 18,
        "OnWrapUpPause": 19,
        "OnWrapUpStop": 20,
        "UpdateVirtualNumber": 21,
        "NewOutgoingCall": 22,
        "UpdateClient": 23,
        'CalendarRefresh': 40,
        // Appointment messages
        'AppointmentInform': 50,                
        'AgendaStateUpdate': 51,
        'AppointmentPaymentUpdate' : 52,
        'VideoConsultStarted' : 53,
        'UserDeactivationStateUpdate': 55,
    });

    module.constant('CallPhoneStatus', {
        "CONNECTED": "CONNECTED",
        "IDLE": "IDLE",
        "RINGING": "RINGING"
    });

    module.constant('CalendarBroadcast', {
        "SelectDate": "select:date"
    });
    
    // which format should be used for the report
    module.constant('ExportFormat', {
        "PDF": { name: "PDF", value: 0 },
        "CSV": { name: "CSV", value: 1 },
        "WORD": { name: "WORD", value: 2 }
    });
    module.constant('Weekday', {
        "Monday": { name: "monday", value: 1 },
        "Tuesday": { name: "tuesday", value: 2 },
        "Wednesday": { name: "wednesday", value: 3 },
        "Thursday": { name: "thursday", value: 4 },
        "Friday": { name: "friday", value: 5 },
        "Saturday": { name: "saturday", value: 6 },
        "Sunday": { name: "sunday", value: 7 },
        "Holiday": { name: "holiday", value: 8 }
    });

    module.constant('UserContactInfoTypeEnum', {
        "Phone": { caption: "Phone", value: 1 },
        "Mobile": { caption: "Mobile", value: 2 },
        "Email": { caption: "Email", value: 3 },
    });
    
    module.constant('BackgroundJobState', {
        "None" : { caption: "None", value: 0 },
        "Enqueued" : { caption: "Enqueued", value: 1 },
        "Started" : { caption: "Started", value: 2 },
        "Finished" : { caption: "Finished", value: 3 },
        "Failed" : { caption: "Failed", value: 4 },
    });

    module.constant('ItemsPerPage', {
        "Default" : { value: 15 },
        "UserCards" : { value: 20 },
    });

    module.constant('IntegratorTypeEnum', {
        "Mediris": { caption: "Mediris", value: 1 },
        "Eyefile": { caption: "Eyefile", value: 2 },
        "CareconnectGp": { caption: "CareconnectGp", value: 3 },
        "GoogleCalendar": { caption: "GoogleCalendar", value: 4 },
    });
    
    // app run 
    module.run(['$rootScope', '$state', '$stateParams', 'SharedAgendaService', 'AuthenticationService',
        function ($rootScope, $state, $stateParams, SharedAgendaService, AuthenticationService) {
            // log out (clean)
            AuthenticationService.logout(true);

            // if we detect a token in the URL, use the AuthenticationService to store it then use it in the LoginController
            const hash = window.location.hash.substring(1);
            const params = new URLSearchParams(hash.replace("!#", ""));
            const idToken = params.get("id_token");
            if (idToken) {
                AuthenticationService.setCorilusPassportIdToken(idToken);
            }
            
            // metronic specific
            //todo-alex das wird bei den linken Navigationen benötigt, da dort auf state.include abgefragt wird, damit der "active" state gesetzt wird.
            //ev eine bessere möglichkeit suchen, damit nicht immer das komplette state-objekt in den scope gelegt wird
            $rootScope.$state = $state; // state to be accessed from view

            // proof if view needs login before
            $rootScope.$on('$stateChangeStart', function (event, toState, toParams) {
                // check if new state needs login
                const user = SharedAgendaService.getLoggedInUserData();
                if (toState.data && toState.data.requiresLogin && (user === null || typeof user === 'undefined' || Object.keys(user).length === 0)) {
                    event.preventDefault();
                    // go to login 
                    $state.go('Login', toParams, { 'reload': true });
                } // if          
            });

            $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
                console.log(error);
            });

            $state.go('Login', $stateParams);
        }]);

    // app configuration
    module.config(['$stateProvider', '$urlRouterProvider', '$locationProvider', '$compileProvider', '$translateProvider', '$httpProvider', '$breadcrumbProvider', 'Language', 'CacheFactoryProvider', 'tmhDynamicLocaleProvider',
        function ($stateProvider, $urlRouterProvider, $locationProvider, $compileProvider, $translateProvider, $httpProvider, $breadcrumbProvider, Language, CacheFactoryProvider, tmhDynamicLocaleProvider) {

            $locationProvider.hashPrefix('!');
            // routing
            $urlRouterProvider.otherwise('/');

            $stateProvider
                .state('Home', {
                    abstract: true,
                    url: '/',
                    templateUrl: '/app/global/templates/rf-global-main.template.html',
                    controller: 'MainController',
                    controllerAs: 'vm',
                    data: {
                        requiresLogin: true
                    },
                    ncyBreadcrumb: {
                        label: 'Home'
                    }
                })
                .state('NewAppointment', {
                    url: '/new-appointment?agendaId?userId?firstname?lastname?phone?eyefileuserid?birthdate',
                    controller: 'NewAppointmentController',
                    template: '&nbsp;',
                    data: {
                        requiresLogin: false
                    },
                });


            // breadcrump init
            $breadcrumbProvider.setOptions({
                prefixStateName: 'Home'
            });

            // Locale Provider Path
            tmhDynamicLocaleProvider.localeLocationPattern('/assets/lib/angular-i18n/angular-locale_{{locale}}.js');            
            
            // configure translations
            $translateProvider
                .useLoader('TranslationAsyncLoader')
                .preferredLanguage(Language.PreferredLanguage)
                .fallbackLanguage(Language.PreferredLanguage);  // if no language id is found
            $translateProvider.forceAsyncReload(true);

            // Wrap HTML in parameters in $sce.trustAsHtml(value)
            $translateProvider.useSanitizeValueStrategy('sceParameters');

            //// HINWEIS: hier noch ein http-interceptor schreiben, der ev. die 401 unauthorized codes oder dergleichen ausliest und weiterleitet
            // add http interceptor to provider (called on every request)
            $httpProvider.interceptors.push('HttpInterceptor');

            // FOR PRODUCTION
            $httpProvider.useApplyAsync(true);
            $compileProvider.debugInfoEnabled(false);
        }]);

    // Footer Controller
    module.controller('FooterController', ['$scope', function ($scope) {
        $scope.$on('$includeContentLoaded', function () {
            Layout.initFooter();
        });
    }]);

    // App Main Controller
    module.controller('MainController', ['$rootScope', '$scope', '$state', 'WebsocketService', 'Alert', 'WebsocketRegisterType', 'DateService', 'AuthenticationService',
        function ($rootScope, $scope, $state, WebsocketService, Alert, WebsocketRegisterType, DateService, AuthenticationService) {
            var vm = this;
            // set current date 
            DateService.date(new Date());

            // listen to broadcast-events from http-interceptor
            $rootScope.$on('unauthorized', function () {
                console.error("User is unauthorized");
                AuthenticationService.logout();
                // go to login
                $state.go('Login');
            });

            // notification service (websocket)
            var ws = WebsocketService.register(WebsocketRegisterType.Notification, function (message) {
                if (message.info === 'information') { Alert.info(message.data.message); }
                else { Alert.success(message.data.message); }
                $scope.$evalAsync();
            });

            $scope.$on("$destroy", function () {
                if (ws) { WebsocketService.unregister(ws.id); }
            });

        }]);

        
        
        function fetchData() {
            var initInjector = angular.injector(["ng"]);
            var $http = initInjector.get("$http");
        
            return $http.get("/app-config.json").then(
                function(response) {
                    module.constant("AppConfig", response.data);
                },
                function(errorResponse) {
                    // Handle error case
                    console.error('Config could not be loaded', errorResponse);
                }
            );
        }
        
        function bootstrapApplication() {
            angular.element(document).ready(function() {
                angular.bootstrap(document, ["uwAgenda"]);
            });
        }
})();